import React from 'react';

const HeroContent = ({ onJoinWaitlist }) => {
    return (
        <section id="home" className="min-h-screen flex items-center justify-center relative scroll-mt-0">
            {/* Full-Screen Background */}
            <div
                className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat z-0 hidden lg:block"
                style={{
                    backgroundImage: 'url("hero-sectgion-bgd.gif")',
                    opacity: 0.7,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '100vw',
                    height: '100vh',
                }}
                />

               {/* ✅ Mobile Only (max-width: 639px) */}
                <div
                className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat z-0 block sm:hidden"
                style={{
                    backgroundImage: 'url("herosgphntblt.gif")',
                    opacity: 0.7,
                    left: '63%',
                    transform: 'translateX(-50%)',
                    width: '150vw',
                    height: '100vh',
                }}
                />

                {/* ✅ Tablet Only (640px to 1023px) */}
                <div
                className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat z-0 hidden sm:block lg:hidden"
                style={{
                    backgroundImage: 'url("herosgphntblt.gif")',
                    opacity: 0.7,
                    left: '80%',
                    transform: 'translateX(-50%)',
                    width: '150vw',
                    height: '100vh',
                }}
                />

                {/* Content */}
                <div className="container mx-auto px-6 sm:px-8 md:px-20 relative z-10 pt-20 ">
                    <div className="grid grid-cols-1 gap-8 ml-[-25px] md:ml-[-72px]">
                        <div className="max-w-5xl px-6">
                            {/* Intro Line */}
                            <h1 className="text-[32px] sm:text-[40px] md:text-[48px] lg:text-[56px] tracking-wide leading-[1.2] text-white mb-4 font-funnel">
                                <span className="text-yellow-400 font-bold">Introducing Infinity –</span>
                            </h1>

                            {/* Main Headline */}
                            <h1 className="text-[32px] sm:text-[40px] md:text-[48px] lg:text-[56px] leading-[1.2] text-white mb-8 font-bold font-funnel">
                                The Intelligent Collar Powering the Total Pet Wellness Ecosystem
                            </h1>

                            {/* Description */}
                            <p className="mt-3 text-[16px] sm:text-[18px] md:text-[20px] max-w-[51rem] py-4 leading-[1.7] text-white font-light font-funnel">
                                Start with the Infinity App. Build smarter habits. Then unlock the intelligent collar for total health, safety & wellness — all in one trusted ecosystem.
                            </p>

                            {/* Join the Waitlist Button */}
                            <button
                                onClick={onJoinWaitlist}
                                className="text-white border border-yellow-400 mt-6 px-8 py-3 rounded-[10px] shadow-md hover:shadow-[0_4px_24px_#FFE13566] transition text-[16px] md:text-[18px] font-medium"
                                type="button"
                            >
                                Join the Waitlist
                            </button>


                            
                        </div>
                    </div>
                </div>
        </section>
    );
};

export default HeroContent;
